import { Paper, Table, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { AvailabilityPeriodItemDesktop } from "./availability-item";

export const AvailabilityPeriodList = ({
  availabilityPeriods,
  refetch,
  showActions,
  franchises,
}) => {
  if (!availabilityPeriods?.length) return null;
  return (
       <TableContainer  component={Paper}>
         <Table sx={{ minWidth: 650 }} >
        <TableHead  >
          <TableRow>
            {/* <TableCell className='tw-font-bold'>Id</TableCell>  */}
            <TableCell className='tw-font-bold'>Day</TableCell> 
            <TableCell className='tw-font-bold'>Date Range</TableCell>
            <TableCell className='tw-font-bold'>Times</TableCell>
            {showActions && (
              <TableCell className='tw-font-bold'>Actions</TableCell>
            )}
          </TableRow>
          {
            availabilityPeriods.map((item) => (
              <AvailabilityPeriodItemDesktop
              franchises={franchises}
              key={item.id}
              availabilityPeriod={item}
              refetch={refetch}
              showActions={showActions}
              />
            ))
          }
        </TableHead>
        </Table>
        </TableContainer>
  );
};